export default __webpack_public_path__ + "static/media/develop.1ca05902.gif";